import { PriceItemDtoResponseWrapper, TotalCarPriceRequest } from "api"
import { Canceler } from "axios"
import qs from "qs"
import axios, { CancelToken } from "./axios"

export let cancelGetPricesRequest: Canceler | undefined

export const getPricesWithCancellation = (
  detailingCode: string,
  colorCode: string,
  upholsteryCode: string,
  accessoriesCodes: string[]
) =>
  axios.get<PriceItemDtoResponseWrapper>("/api/ecomm/prices", {
    params: {
      finishingLevelCode: detailingCode,
      colorCode,
      upholsteryCode,
      carExtraCodes: accessoriesCodes,
    },
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    cancelToken: new CancelToken((c) => {
      cancelGetPricesRequest = c
    }),
  })

export const postEcommPricesWithCancellation = (data: TotalCarPriceRequest) =>
  axios.post<PriceItemDtoResponseWrapper>(`/api/ecomm/prices`, data, {
    paramsSerializer: (params) =>
      qs.stringify(params, { arrayFormat: "repeat" }),
    cancelToken: new CancelToken((c) => {
      cancelGetPricesRequest = c
    }),
  })
